<template>
  <div class="instagram-feed">
    <thumbnail v-for="(post, i) in orderedPosts" :key="i" :post="post" @click="currentPost = post"></thumbnail>
    <div class="view-more"><a :href="'https://www.instagram.com/explore/tags/' + firstHashTag" @click="onViewMoreClick">View More</a></div>
    <transition name="fadepopup">
      <pop-up v-if="currentPost" @close="currentPost = null">
        <component :post="currentPost" :is="currentPost.postType"></component>
        <div class="text-content">
          <div class="user">
            <img v-if="currentPost.profilePic" :src="currentPost.profilePic"/>
            <span v-html="currentPost.name"></span>
          </div>
          <div class="text">
            <strong v-if="currentPost.subName">{{currentPost.subName}}</strong>
            <span v-for="(caption, i) in currentPost.captions" :key="i" v-html="caption"></span>
          </div>
        </div>
      </pop-up>
    </transition>
  </div>
</template>

<script>
// import {store, fetchFeedManual} from './store'

import * as InstaComponents from './components/index'
import Thumbnail from './Thumbnail.vue'
import PopUp from './PopUp.vue'

const JSON_ENDPOINT = process.env.NODE_ENV === 'production'
  ? 'https://www.straitstimes.com/multimedia/graphics/json/'
  : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

export default {
  props: ['attributes'],
  components: {...InstaComponents, Thumbnail, PopUp},
  data () {
    return {
      blockedPostRef: {},
      currentPost: null,
      hashtags: this.attributes.value.hashtags,
      posts: null
    }
  },
  computed: {
    // posts () {
    //   return store.posts
    // },
    firstHashTag () {
      return this.hashtags[0].replace('#', '')
    },
    orderedPosts () {
      const sortKey = 'timeStamp'
      if (!this.posts) return []
      return Object.keys(this.posts)
        .map(key => this.posts[key])
        .filter(post => post) // filter out post that is set to null
        .sort((a, b) => b[sortKey] - a[sortKey])
        // .sort((a, b) => a[sortKey] - b[sortKey])
    }
  },
  methods: {
    onViewMoreClick () {
      this.$analytics.getClient('eclipse-instagram-feed-2019').track('click', 'btn-view-more')
    },
    getPostType (type, isVideo) {
      if (type === 'GraphSidecar') return 'InstaGallery'
      if (type !== 'GraphSidecar' && isVideo) return 'InstaVideo'
      if (type !== 'GraphSidecar' && !isVideo) return 'InstaPhoto'
    },
    fetchPostManual () {
      return fetch(JSON_ENDPOINT + this.attributes.value.manualposts)
        .then(res => res.json())
        .then(data => {
          const newPosts = {}
          data
          .filter(d => d.username && !d.hide)
          .filter(d => !this.blockedPostRef[d.shortcode])
          .forEach(d => {
            const {username, postType, captionStr, profilePic, previewPic, gallerySrcStr, videoSrc, shortcode, timeStamp} = d
            const name = (username === 'straits_times' && 'The Straits Times') || username
            const subName = null
            const designation = null
            const captions = [captionStr]
            const gallerySrc = gallerySrcStr && gallerySrcStr.split(',').map(src => src.trim())
            newPosts[shortcode] = {
              username, name, subName, designation, postType, captions, profilePic, previewPic, gallerySrc, videoSrc, shortcode, timeStamp
            }
          })
          return newPosts
        })
    }
  },
  mounted () {
    this.blockedPostRef = this.attributes.value.blockedshortcodes.reduce((acc, id) => {
      acc[id] = true
      return acc
    }, {})

    this.$loading.withLoading(() => {
      return this.fetchPostManual()
        .then(posts => {
          this.posts = posts
        })
    })()
  }
}
</script>
<style lang="scss" scoped>
  .instagram-feed {
    max-width: 1340px;
    margin: 0 auto;
    text-align: center;
    .feed-loading.st-loading-container {
      background-color: rgba(255, 255, 255, 0.5) !important;
    }
  }

  .post {
    width: 100%;
    height: 480px;
    display: inline-block;
    padding: 30px 10px;
    overflow: hidden;
    max-width: 300px;
    position: relative;
    text-align: left;
    cursor: pointer;
    vertical-align: top;

    &:hover {
      .btn-video {
        opacity: 1;
      }
    }
    .preview {
      width: 300px;
      height: 300px;
      object-fit: cover;
      border-radius: 10px;
    }
    .btn-video {
      position: absolute;
      left: 50%;
      top: 150px;
      width: 60px;
      transform: translateX(-50%);
      opacity: 0.6;
      transition: opacity .15s ease-out;
    }
    .album-icon {
      position: absolute;
      top: 35px;
      right: 20px;
      font-weight: bold;
      width: 25px;
    }
    .user {
      display: block;
      padding: 10px 0;

      & > * {
        display: inline-block;
        vertical-align: middle;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        padding-right: 10px;
      }

      span {
        font-family: $font-CuratorBold;
        font-size: 16px;
        color: #333;
      }
    }

    .text {
      display: block;
      font-size: 16px;
      color: #333;
      font-family: $font-CuratorRegular;
      word-break: break-word;
    }
  }
  .view-more {
    padding-top: 30px;
    a {
      display: inline;
      outline: none;
      padding: 5px 25px;
      border: 1px solid rgba(12,43,87,.5);
      background-color: transparent;
      border-radius: 25px;
      color: #333;
      text-decoration: none;
      font-family: $font-CuratorRegular;
      text-align: center;
      font-size: 15px;
      transition: border .15s ease-out;
      &:hover {
        border: 1px solid #333;
      }
    }
  }

  .pop-container {
    .text-content {
      text-align: left;
      padding: 0 3%;
      margin: 0 auto;
      max-width: 90%;

      .user {
        padding: 10px 0;

        & > * {
          display: inline-block;
          vertical-align: middle;
        }
        
        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          padding-right: 5px;
        }

        span {
          font-family: $font-CuratorBold;
          font-size: 16px;
          color: #333;
        }
      }

      .text {
        font-size: 16px;
        color: #333;
        font-family: $font-CuratorRegular;
        word-break: break-word;
      }
    }
  }

.fadepopup-enter-active {
  transition: opacity 0.5s;
}

.fadepopup-enter,
.fadepopup-leave-to {
  opacity: 0;
}
</style>
